export const nkd = {
	'1P1': {
		keyMoex: 'RU000A0ZZFP5',
		values: {
			'05.02.2020': 0.0,
			'06.02.2020': 0.32,
			'07.02.2020': 0.63,
			'08.02.2020': 0.96,
			'09.02.2020': 1.27,
			'10.02.2020': 1.58,
			'11.02.2020': 1.89,
			'12.02.2020': 2.21,
			'13.02.2020': 2.52,
			'14.02.2020': 2.84,
			'15.02.2020': 3.15,
			'16.02.2020': 3.47,
			'17.02.2020': 3.78,
			'18.02.2020': 4.1,
			'19.02.2020': 4.41,
			'20.02.2020': 4.73,
			'21.02.2020': 5.04,
			'22.02.2020': 5.36,
			'23.02.2020': 5.67,
			'24.02.2020': 5.99,
			'25.02.2020': 6.3,
			'26.02.2020': 6.62,
			'27.02.2020': 6.93,
			'28.02.2020': 7.25,
			'29.02.2020': 7.58,
			'01.03.2020': 7.89,
			'02.03.2020': 8.19,
			'03.03.2020': 8.51,
			'04.03.2020': 8.82,
			'05.03.2020': 9.14,
			'06.03.2020': 9.45,
			'07.03.2020': 9.77,
			'08.03.2020': 10.08,
			'09.03.2020': 10.4,
			'10.03.2020': 10.71,
			'11.03.2020': 11.03,
			'12.03.2020': 11.34,
			'13.03.2020': 11.66,
			'14.03.2020': 11.98,
			'15.03.2020': 12.29,
			'16.03.2020': 12.6,
			'17.03.2020': 12.92,
			'18.03.2020': 13.23,
			'19.03.2020': 13.55,
			'20.03.2020': 13.86,
			'21.03.2020': 14.18,
			'22.03.2020': 14.5,
			'23.03.2020': 14.81,
			'24.03.2020': 15.12,
			'25.03.2020': 15.44,
			'26.03.2020': 15.75,
			'27.03.2020': 16.07,
			'28.03.2020': 16.39,
			'29.03.2020': 16.7,
			'30.03.2020': 17.01,
			'31.03.2020': 17.33,
			'01.04.2020': 17.64,
			'02.04.2020': 17.96,
			'03.04.2020': 18.27,
			'04.04.2020': 18.59,
			'05.04.2020': 18.91,
			'06.04.2020': 19.22,
			'07.04.2020': 19.53,
			'08.04.2020': 19.85,
			'09.04.2020': 20.16,
			'10.04.2020': 20.48,
			'11.04.2020': 20.8,
			'12.04.2020': 21.11,
			'13.04.2020': 21.42,
			'14.04.2020': 21.74,
			'15.04.2020': 22.05,
			'16.04.2020': 22.37,
			'17.04.2020': 22.68,
			'18.04.2020': 23.0,
			'19.04.2020': 23.32,
			'20.04.2020': 23.63,
			'21.04.2020': 23.95,
			'22.04.2020': 24.26,
			'23.04.2020': 24.58,
			'24.04.2020': 24.89,
			'25.04.2020': 25.21,
			'26.04.2020': 25.52,
			'27.04.2020': 25.84,
			'28.04.2020': 26.15,
			'29.04.2020': 26.47,
			'30.04.2020': 26.78,
			'01.05.2020': 27.1,
			'02.05.2020': 27.41,
			'03.05.2020': 27.73,
			'04.05.2020': 28.04,
			'05.05.2020': 28.36,
			'06.05.2020': 0.0,
			'07.05.2020': 0.32,
			'08.05.2020': 0.63,
			'09.05.2020': 0.96,
			'10.05.2020': 1.27,
			'11.05.2020': 1.58,
			'12.05.2020': 1.89,
			'13.05.2020': 2.21,
			'14.05.2020': 2.52,
			'15.05.2020': 2.84,
			'16.05.2020': 3.15,
			'17.05.2020': 3.47,
			'18.05.2020': 3.78,
			'19.05.2020': 4.1,
			'20.05.2020': 4.41,
			'21.05.2020': 4.73,
			'22.05.2020': 5.04,
			'23.05.2020': 5.36,
			'24.05.2020': 5.67,
			'25.05.2020': 5.99,
			'26.05.2020': 6.3,
			'27.05.2020': 6.62,
			'28.05.2020': 6.93,
			'29.05.2020': 7.25,
			'30.05.2020': 7.58,
			'31.05.2020': 7.89,
			'01.06.2020': 8.19,
			'02.06.2020': 8.51,
			'03.06.2020': 8.82,
			'04.06.2020': 9.14,
			'05.06.2020': 9.45,
			'06.06.2020': 9.77,
			'07.06.2020': 10.08,
			'08.06.2020': 10.4,
			'09.06.2020': 10.71,
			'10.06.2020': 11.03,
			'11.06.2020': 11.34,
			'12.06.2020': 11.66,
			'13.06.2020': 11.98,
			'14.06.2020': 12.29,
			'15.06.2020': 12.6,
			'16.06.2020': 12.92,
			'17.06.2020': 13.23,
			'18.06.2020': 13.55,
			'19.06.2020': 13.86,
			'20.06.2020': 14.18,
			'21.06.2020': 14.5,
			'22.06.2020': 14.81,
			'23.06.2020': 15.12,
			'24.06.2020': 15.44,
			'25.06.2020': 15.75,
			'26.06.2020': 16.07,
			'27.06.2020': 16.39,
			'28.06.2020': 16.7,
			'29.06.2020': 17.01,
			'30.06.2020': 17.33,
			'01.07.2020': 17.64,
			'02.07.2020': 17.96,
			'03.07.2020': 18.27,
			'04.07.2020': 18.59,
			'05.07.2020': 18.91,
			'06.07.2020': 19.22,
			'07.07.2020': 19.53,
			'08.07.2020': 19.85,
			'09.07.2020': 20.16,
			'10.07.2020': 20.48,
			'11.07.2020': 20.8,
			'12.07.2020': 21.11,
			'13.07.2020': 21.42,
			'14.07.2020': 21.74,
			'15.07.2020': 22.05,
			'16.07.2020': 22.37,
			'17.07.2020': 22.68,
			'18.07.2020': 23.0,
			'19.07.2020': 23.32,
			'20.07.2020': 23.63,
			'21.07.2020': 23.95,
			'22.07.2020': 24.26,
			'23.07.2020': 24.58,
			'24.07.2020': 24.89,
			'25.07.2020': 25.21,
			'26.07.2020': 25.52,
			'27.07.2020': 25.84,
			'28.07.2020': 26.15,
			'29.07.2020': 26.47,
			'30.07.2020': 26.78,
			'31.07.2020': 27.1,
			'01.08.2020': 27.41,
			'02.08.2020': 27.73,
			'03.08.2020': 28.04,
			'04.08.2020': 28.36,
			'05.08.2020': 0.0,
			'06.08.2020': 0.32,
			'07.08.2020': 0.63,
			'08.08.2020': 0.96,
			'09.08.2020': 1.27,
			'10.08.2020': 1.58,
			'11.08.2020': 1.89,
			'12.08.2020': 2.21,
			'13.08.2020': 2.52,
			'14.08.2020': 2.84,
			'15.08.2020': 3.15,
			'16.08.2020': 3.47,
			'17.08.2020': 3.78,
			'18.08.2020': 4.1,
			'19.08.2020': 4.41,
			'20.08.2020': 4.73,
			'21.08.2020': 5.04,
			'22.08.2020': 5.36,
			'23.08.2020': 5.67,
			'24.08.2020': 5.99,
			'25.08.2020': 6.3,
			'26.08.2020': 6.62,
			'27.08.2020': 6.93,
			'28.08.2020': 7.25,
			'29.08.2020': 7.58,
			'30.08.2020': 7.89,
			'31.08.2020': 8.19,
			'01.09.2020': 8.51,
			'02.09.2020': 8.82,
			'03.09.2020': 9.14,
			'04.09.2020': 9.45,
			'05.09.2020': 9.77,
			'06.09.2020': 10.08,
			'07.09.2020': 10.4,
			'08.09.2020': 10.71,
			'09.09.2020': 11.03,
			'10.09.2020': 11.34,
			'11.09.2020': 11.66,
			'12.09.2020': 11.98,
			'13.09.2020': 12.29,
			'14.09.2020': 12.6,
			'15.09.2020': 12.92,
			'16.09.2020': 13.23,
			'17.09.2020': 13.55,
			'18.09.2020': 13.86,
			'19.09.2020': 14.18,
			'20.09.2020': 14.5,
			'21.09.2020': 14.81,
			'22.09.2020': 15.12,
			'23.09.2020': 15.44,
			'24.09.2020': 15.75,
			'25.09.2020': 16.07,
			'26.09.2020': 16.39,
			'27.09.2020': 16.7,
			'28.09.2020': 17.01,
			'29.09.2020': 17.33,
			'30.09.2020': 17.64,
			'01.10.2020': 17.96,
			'02.10.2020': 18.27,
			'03.10.2020': 18.59,
			'04.10.2020': 18.91,
			'05.10.2020': 19.22,
			'06.10.2020': 19.53,
			'07.10.2020': 19.85,
			'08.10.2020': 20.16,
			'09.10.2020': 20.48,
			'10.10.2020': 20.8,
			'11.10.2020': 21.11,
			'12.10.2020': 21.42,
			'13.10.2020': 21.74,
			'14.10.2020': 22.05,
			'15.10.2020': 22.37,
			'16.10.2020': 22.68,
			'17.10.2020': 23.0,
			'18.10.2020': 23.32,
			'19.10.2020': 23.63,
			'20.10.2020': 23.95,
			'21.10.2020': 24.26,
			'22.10.2020': 24.58,
			'23.10.2020': 24.89,
			'24.10.2020': 25.21,
			'25.10.2020': 25.52,
			'26.10.2020': 25.84,
			'27.10.2020': 26.15,
			'28.10.2020': 26.47,
			'29.10.2020': 26.78,
			'30.10.2020': 27.1,
			'31.10.2020': 27.41,
			'01.11.2020': 27.73,
			'02.11.2020': 28.04,
			'03.11.2020': 28.36,
			'04.11.2020': 0.0,
			'05.11.2020': 0.32,
			'06.11.2020': 0.63,
			'07.11.2020': 0.96,
			'08.11.2020': 1.27,
			'09.11.2020': 1.58,
			'10.11.2020': 1.89,
			'11.11.2020': 2.21,
			'12.11.2020': 2.52,
			'13.11.2020': 2.84,
			'14.11.2020': 3.15,
			'15.11.2020': 3.47,
			'16.11.2020': 3.78,
			'17.11.2020': 4.1,
			'18.11.2020': 4.41,
			'19.11.2020': 4.73,
			'20.11.2020': 5.04,
			'21.11.2020': 5.36,
			'22.11.2020': 5.67,
			'23.11.2020': 5.99,
			'24.11.2020': 6.3,
			'25.11.2020': 6.62,
			'26.11.2020': 6.93,
			'27.11.2020': 7.25,
			'28.11.2020': 7.58,
			'29.11.2020': 7.89,
			'30.11.2020': 8.19,
			'01.12.2020': 8.51,
			'02.12.2020': 8.82,
			'03.12.2020': 9.14,
			'04.12.2020': 9.45,
			'05.12.2020': 9.77,
			'06.12.2020': 10.08,
			'07.12.2020': 10.4,
			'08.12.2020': 10.71,
			'09.12.2020': 11.03,
			'10.12.2020': 11.34,
			'11.12.2020': 11.66,
			'12.12.2020': 11.98,
			'13.12.2020': 12.29,
			'14.12.2020': 12.6,
			'15.12.2020': 12.92,
			'16.12.2020': 13.23,
			'17.12.2020': 13.55,
			'18.12.2020': 13.86,
			'19.12.2020': 14.18,
			'20.12.2020': 14.5,
			'21.12.2020': 14.81,
			'22.12.2020': 15.12,
			'23.12.2020': 15.44,
			'24.12.2020': 15.75,
			'25.12.2020': 16.07,
			'26.12.2020': 16.39,
			'27.12.2020': 16.7,
			'28.12.2020': 17.01,
			'29.12.2020': 17.33,
			'30.12.2020': 17.64,
			'31.12.2020': 17.96,
			'01.01.2021': 18.27,
			'02.01.2021': 18.59,
			'03.01.2021': 18.91,
			'04.01.2021': 19.22,
			'05.01.2021': 19.53,
			'06.01.2021': 19.85,
			'07.01.2021': 20.16,
			'08.01.2021': 20.48,
			'09.01.2021': 20.8,
			'10.01.2021': 21.11,
			'11.01.2021': 21.42,
			'12.01.2021': 21.74,
			'13.01.2021': 22.05,
			'14.01.2021': 22.37,
			'15.01.2021': 22.68,
			'16.01.2021': 23.0,
			'17.01.2021': 23.32,
			'18.01.2021': 23.63,
			'19.01.2021': 23.95,
			'20.01.2021': 24.26,
			'21.01.2021': 24.58,
			'22.01.2021': 24.89,
			'23.01.2021': 25.21,
			'24.01.2021': 25.52,
			'25.01.2021': 25.84,
			'26.01.2021': 26.15,
			'27.01.2021': 26.47,
			'28.01.2021': 26.78,
			'29.01.2021': 27.1,
			'30.01.2021': 27.41,
			'31.01.2021': 27.73,
			'01.02.2021': 28.04,
			'02.02.2021': 28.36,
			'03.02.2021': 0.0
		}
	},
	'1P2': {
		keyMoex: 'RU000A0ZZX35',
		values: {
			'09.09.2019': 0.0,
			'10.09.2019': 0.34,
			'11.09.2019': 0.68,
			'12.09.2019': 1.03,
			'13.09.2019': 1.37,
			'14.09.2019': 1.72,
			'15.09.2019': 2.06,
			'16.09.2019': 2.4,
			'17.09.2019': 2.74,
			'18.09.2019': 3.08,
			'19.09.2019': 3.42,
			'20.09.2019': 3.77,
			'21.09.2019': 4.11,
			'22.09.2019': 4.45,
			'23.09.2019': 4.79,
			'24.09.2019': 5.14,
			'25.09.2019': 5.48,
			'26.09.2019': 5.82,
			'27.09.2019': 6.16,
			'28.09.2019': 6.51,
			'29.09.2019': 6.85,
			'30.09.2019': 7.19,
			'01.10.2019': 7.53,
			'02.10.2019': 7.88,
			'03.10.2019': 8.22,
			'04.10.2019': 8.56,
			'05.10.2019': 8.91,
			'06.10.2019': 9.25,
			'07.10.2019': 9.59,
			'08.10.2019': 9.93,
			'09.10.2019': 10.27,
			'10.10.2019': 10.62,
			'11.10.2019': 10.96,
			'12.10.2019': 11.31,
			'13.10.2019': 11.65,
			'14.10.2019': 11.99,
			'15.10.2019': 12.33,
			'16.10.2019': 12.67,
			'17.10.2019': 13.01,
			'18.10.2019': 13.36,
			'19.10.2019': 13.7,
			'20.10.2019': 14.04,
			'21.10.2019': 14.38,
			'22.10.2019': 14.73,
			'23.10.2019': 15.07,
			'24.10.2019': 15.41,
			'25.10.2019': 15.75,
			'26.10.2019': 16.1,
			'27.10.2019': 16.44,
			'28.10.2019': 16.78,
			'29.10.2019': 17.12,
			'30.10.2019': 17.47,
			'31.10.2019': 17.81,
			'01.11.2019': 18.15,
			'02.11.2019': 18.5,
			'03.11.2019': 18.84,
			'04.11.2019': 19.18,
			'05.11.2019': 19.52,
			'06.11.2019': 19.86,
			'07.11.2019': 20.21,
			'08.11.2019': 20.55,
			'09.11.2019': 20.9,
			'10.11.2019': 21.24,
			'11.11.2019': 21.58,
			'12.11.2019': 21.92,
			'13.11.2019': 22.26,
			'14.11.2019': 22.6,
			'15.11.2019': 22.95,
			'16.11.2019': 23.29,
			'17.11.2019': 23.63,
			'18.11.2019': 23.97,
			'19.11.2019': 24.32,
			'20.11.2019': 24.66,
			'21.11.2019': 25.0,
			'22.11.2019': 25.34,
			'23.11.2019': 25.69,
			'24.11.2019': 26.03,
			'25.11.2019': 26.37,
			'26.11.2019': 26.71,
			'27.11.2019': 27.05,
			'28.11.2019': 27.4,
			'29.11.2019': 27.74,
			'30.11.2019': 28.09,
			'01.12.2019': 28.43,
			'02.12.2019': 28.77,
			'03.12.2019': 29.11,
			'04.12.2019': 29.45,
			'05.12.2019': 29.79,
			'06.12.2019': 30.14,
			'07.12.2019': 30.48,
			'08.12.2019': 30.82,
			'09.12.2019': 0.0,
			'10.12.2019': 0.34,
			'11.12.2019': 0.68,
			'12.12.2019': 1.03,
			'13.12.2019': 1.37,
			'14.12.2019': 1.72,
			'15.12.2019': 2.06,
			'16.12.2019': 2.4,
			'17.12.2019': 2.74,
			'18.12.2019': 3.08,
			'19.12.2019': 3.42,
			'20.12.2019': 3.77,
			'21.12.2019': 4.11,
			'22.12.2019': 4.45,
			'23.12.2019': 4.79,
			'24.12.2019': 5.14,
			'25.12.2019': 5.48,
			'26.12.2019': 5.82,
			'27.12.2019': 6.16,
			'28.12.2019': 6.51,
			'29.12.2019': 6.85,
			'30.12.2019': 7.19,
			'31.12.2019': 7.53,
			'01.01.2020': 7.88,
			'02.01.2020': 8.22,
			'03.01.2020': 8.56,
			'04.01.2020': 8.91,
			'05.01.2020': 9.25,
			'06.01.2020': 9.59,
			'07.01.2020': 9.93,
			'08.01.2020': 10.27,
			'09.01.2020': 10.62,
			'10.01.2020': 10.96,
			'11.01.2020': 11.31,
			'12.01.2020': 11.65,
			'13.01.2020': 11.99,
			'14.01.2020': 12.33,
			'15.01.2020': 12.67,
			'16.01.2020': 13.01,
			'17.01.2020': 13.36,
			'18.01.2020': 13.7,
			'19.01.2020': 14.04,
			'20.01.2020': 14.38,
			'21.01.2020': 14.73,
			'22.01.2020': 15.07,
			'23.01.2020': 15.41,
			'24.01.2020': 15.75,
			'25.01.2020': 16.1,
			'26.01.2020': 16.44,
			'27.01.2020': 16.78,
			'28.01.2020': 17.12,
			'29.01.2020': 17.47,
			'30.01.2020': 17.81,
			'31.01.2020': 18.15,
			'01.02.2020': 18.5,
			'02.02.2020': 18.84,
			'03.02.2020': 19.18,
			'04.02.2020': 19.52,
			'05.02.2020': 19.86,
			'06.02.2020': 20.21,
			'07.02.2020': 20.55,
			'08.02.2020': 20.9,
			'09.02.2020': 21.24,
			'10.02.2020': 21.58,
			'11.02.2020': 21.92,
			'12.02.2020': 22.26,
			'13.02.2020': 22.6,
			'14.02.2020': 22.95,
			'15.02.2020': 23.29,
			'16.02.2020': 23.63,
			'17.02.2020': 23.97,
			'18.02.2020': 24.32,
			'19.02.2020': 24.66,
			'20.02.2020': 25.0,
			'21.02.2020': 25.34,
			'22.02.2020': 25.69,
			'23.02.2020': 26.03,
			'24.02.2020': 26.37,
			'25.02.2020': 26.71,
			'26.02.2020': 27.05,
			'27.02.2020': 27.4,
			'28.02.2020': 27.74,
			'29.02.2020': 28.09,
			'01.03.2020': 28.43,
			'02.03.2020': 28.77,
			'03.03.2020': 29.11,
			'04.03.2020': 29.45,
			'05.03.2020': 29.79,
			'06.03.2020': 30.14,
			'07.03.2020': 30.48,
			'08.03.2020': 30.82,
			'09.03.2020': 0.0,
			'10.03.2020': 0.34,
			'11.03.2020': 0.68,
			'12.03.2020': 1.03,
			'13.03.2020': 1.37,
			'14.03.2020': 1.72,
			'15.03.2020': 2.06,
			'16.03.2020': 2.4,
			'17.03.2020': 2.74,
			'18.03.2020': 3.08,
			'19.03.2020': 3.42,
			'20.03.2020': 3.77,
			'21.03.2020': 4.11,
			'22.03.2020': 4.45,
			'23.03.2020': 4.79,
			'24.03.2020': 5.14,
			'25.03.2020': 5.48,
			'26.03.2020': 5.82,
			'27.03.2020': 6.16,
			'28.03.2020': 6.51,
			'29.03.2020': 6.85,
			'30.03.2020': 7.19,
			'31.03.2020': 7.53,
			'01.04.2020': 7.88,
			'02.04.2020': 8.22,
			'03.04.2020': 8.56,
			'04.04.2020': 8.91,
			'05.04.2020': 9.25,
			'06.04.2020': 9.59,
			'07.04.2020': 9.93,
			'08.04.2020': 10.27,
			'09.04.2020': 10.62,
			'10.04.2020': 10.96,
			'11.04.2020': 11.31,
			'12.04.2020': 11.65,
			'13.04.2020': 11.99,
			'14.04.2020': 12.33,
			'15.04.2020': 12.67,
			'16.04.2020': 13.01,
			'17.04.2020': 13.36,
			'18.04.2020': 13.7,
			'19.04.2020': 14.04,
			'20.04.2020': 14.38,
			'21.04.2020': 14.73,
			'22.04.2020': 15.07,
			'23.04.2020': 15.41,
			'24.04.2020': 15.75,
			'25.04.2020': 16.1,
			'26.04.2020': 16.44,
			'27.04.2020': 16.78,
			'28.04.2020': 17.12,
			'29.04.2020': 17.47,
			'30.04.2020': 17.81,
			'01.05.2020': 18.15,
			'02.05.2020': 18.5,
			'03.05.2020': 18.84,
			'04.05.2020': 19.18,
			'05.05.2020': 19.52,
			'06.05.2020': 19.86,
			'07.05.2020': 20.21,
			'08.05.2020': 20.55,
			'09.05.2020': 20.9,
			'10.05.2020': 21.24,
			'11.05.2020': 21.58,
			'12.05.2020': 21.92,
			'13.05.2020': 22.26,
			'14.05.2020': 22.6,
			'15.05.2020': 22.95,
			'16.05.2020': 23.29,
			'17.05.2020': 23.63,
			'18.05.2020': 23.97,
			'19.05.2020': 24.32,
			'20.05.2020': 24.66,
			'21.05.2020': 25.0,
			'22.05.2020': 25.34,
			'23.05.2020': 25.69,
			'24.05.2020': 26.03,
			'25.05.2020': 26.37,
			'26.05.2020': 26.71,
			'27.05.2020': 27.05,
			'28.05.2020': 27.4,
			'29.05.2020': 27.74,
			'30.05.2020': 28.09,
			'31.05.2020': 28.43,
			'01.06.2020': 28.77,
			'02.06.2020': 29.11,
			'03.06.2020': 29.45,
			'04.06.2020': 29.79,
			'05.06.2020': 30.14,
			'06.06.2020': 30.48,
			'07.06.2020': 30.82,
			'08.06.2020': 0.0,
			'09.06.2020': 0.29,
			'10.06.2020': 0.58,
			'11.06.2020': 0.86,
			'12.06.2020': 1.15,
			'13.06.2020': 1.44,
			'14.06.2020': 1.73,
			'15.06.2020': 2.01,
			'16.06.2020': 2.3,
			'17.06.2020': 2.59,
			'18.06.2020': 2.88,
			'19.06.2020': 3.16,
			'20.06.2020': 3.45,
			'21.06.2020': 3.74,
			'22.06.2020': 4.03,
			'23.06.2020': 4.32,
			'24.06.2020': 4.6,
			'25.06.2020': 4.89,
			'26.06.2020': 5.18,
			'27.06.2020': 5.47,
			'28.06.2020': 5.75,
			'29.06.2020': 6.04,
			'30.06.2020': 6.33,
			'01.07.2020': 6.62,
			'02.07.2020': 6.9,
			'03.07.2020': 7.19,
			'04.07.2020': 7.48,
			'05.07.2020': 7.77,
			'06.07.2020': 8.05,
			'07.07.2020': 8.34,
			'08.07.2020': 8.63,
			'09.07.2020': 8.92,
			'10.07.2020': 9.21,
			'11.07.2020': 9.49,
			'12.07.2020': 9.78,
			'13.07.2020': 10.07,
			'14.07.2020': 10.36,
			'15.07.2020': 10.64,
			'16.07.2020': 10.93,
			'17.07.2020': 11.22,
			'18.07.2020': 11.51,
			'19.07.2020': 11.79,
			'20.07.2020': 12.08,
			'21.07.2020': 12.37,
			'22.07.2020': 12.66,
			'23.07.2020': 12.95,
			'24.07.2020': 13.23,
			'25.07.2020': 13.52,
			'26.07.2020': 13.81,
			'27.07.2020': 14.1,
			'28.07.2020': 14.38,
			'29.07.2020': 14.67,
			'30.07.2020': 14.96,
			'31.07.2020': 15.25,
			'01.08.2020': 15.53,
			'02.08.2020': 15.82,
			'03.08.2020': 16.11,
			'04.08.2020': 16.4,
			'05.08.2020': 16.68,
			'06.08.2020': 16.97,
			'07.08.2020': 17.26,
			'08.08.2020': 17.55,
			'09.08.2020': 17.84,
			'10.08.2020': 18.12,
			'11.08.2020': 18.41,
			'12.08.2020': 18.7,
			'13.08.2020': 18.99,
			'14.08.2020': 19.27,
			'15.08.2020': 19.56,
			'16.08.2020': 19.85,
			'17.08.2020': 20.14,
			'18.08.2020': 20.42,
			'19.08.2020': 20.71,
			'20.08.2020': 21.0,
			'21.08.2020': 21.29,
			'22.08.2020': 21.58,
			'23.08.2020': 21.86,
			'24.08.2020': 22.15,
			'25.08.2020': 22.44,
			'26.08.2020': 22.73,
			'27.08.2020': 23.01,
			'28.08.2020': 23.3,
			'29.08.2020': 23.59,
			'30.08.2020': 23.88,
			'31.08.2020': 24.16,
			'01.09.2020': 24.45,
			'02.09.2020': 24.74,
			'03.09.2020': 25.03,
			'04.09.2020': 25.32,
			'05.09.2020': 25.6,
			'06.09.2020': 25.89,
			'07.09.2020': 0.0,
			'08.09.2020': 0.29,
			'09.09.2020': 0.58,
			'10.09.2020': 0.86,
			'11.09.2020': 1.15,
			'12.09.2020': 1.44,
			'13.09.2020': 1.73,
			'14.09.2020': 2.01,
			'15.09.2020': 2.3,
			'16.09.2020': 2.59,
			'17.09.2020': 2.88,
			'18.09.2020': 3.16,
			'19.09.2020': 3.45,
			'20.09.2020': 3.74,
			'21.09.2020': 4.03,
			'22.09.2020': 4.32,
			'23.09.2020': 4.6,
			'24.09.2020': 4.89,
			'25.09.2020': 5.18,
			'26.09.2020': 5.47,
			'27.09.2020': 5.75,
			'28.09.2020': 6.04,
			'29.09.2020': 6.33,
			'30.09.2020': 6.62,
			'01.10.2020': 6.9,
			'02.10.2020': 7.19,
			'03.10.2020': 7.48,
			'04.10.2020': 7.77,
			'05.10.2020': 8.05,
			'06.10.2020': 8.34,
			'07.10.2020': 8.63,
			'08.10.2020': 8.92,
			'09.10.2020': 9.21,
			'10.10.2020': 9.49,
			'11.10.2020': 9.78,
			'12.10.2020': 10.07,
			'13.10.2020': 10.36,
			'14.10.2020': 10.64,
			'15.10.2020': 10.93,
			'16.10.2020': 11.22,
			'17.10.2020': 11.51,
			'18.10.2020': 11.79,
			'19.10.2020': 12.08,
			'20.10.2020': 12.37,
			'21.10.2020': 12.66,
			'22.10.2020': 12.95,
			'23.10.2020': 13.23,
			'24.10.2020': 13.52,
			'25.10.2020': 13.81,
			'26.10.2020': 14.1,
			'27.10.2020': 14.38,
			'28.10.2020': 14.67,
			'29.10.2020': 14.96,
			'30.10.2020': 15.25,
			'31.10.2020': 15.53,
			'01.11.2020': 15.82,
			'02.11.2020': 16.11,
			'03.11.2020': 16.4,
			'04.11.2020': 16.68,
			'05.11.2020': 16.97,
			'06.11.2020': 17.26,
			'07.11.2020': 17.55,
			'08.11.2020': 17.84,
			'09.11.2020': 18.12,
			'10.11.2020': 18.41,
			'11.11.2020': 18.7,
			'12.11.2020': 18.99,
			'13.11.2020': 19.27,
			'14.11.2020': 19.56,
			'15.11.2020': 19.85,
			'16.11.2020': 20.14,
			'17.11.2020': 20.42,
			'18.11.2020': 20.71,
			'19.11.2020': 21.0,
			'20.11.2020': 21.29,
			'21.11.2020': 21.58,
			'22.11.2020': 21.86,
			'23.11.2020': 22.15,
			'24.11.2020': 22.44,
			'25.11.2020': 22.73,
			'26.11.2020': 23.01,
			'27.11.2020': 23.3,
			'28.11.2020': 23.59,
			'29.11.2020': 23.88,
			'30.11.2020': 24.16,
			'01.12.2020': 24.45,
			'02.12.2020': 24.74,
			'03.12.2020': 25.03,
			'04.12.2020': 25.32,
			'05.12.2020': 25.6,
			'06.12.2020': 25.89,
			'07.12.2020': 26.18
		}
	},
	'1P3': {
		keyMoex: 'RU000A100Q35',
		values: {
			'13.08.2019': 0,
			'14.08.2019': 0.33,
			'15.08.2019': 0.66,
			'16.08.2019': 0.99,
			'17.08.2019': 1.32,
			'18.08.2019': 1.65,
			'19.08.2019': 1.97,
			'20.08.2019': 2.3,
			'21.08.2019': 2.63,
			'22.08.2019': 2.96,
			'23.08.2019': 3.29,
			'24.08.2019': 3.62,
			'25.08.2019': 3.95,
			'26.08.2019': 4.27,
			'27.08.2019': 4.6,
			'28.08.2019': 4.93,
			'29.08.2019': 5.26,
			'30.08.2019': 5.59,
			'31.08.2019': 5.92,
			'01.09.2019': 6.25,
			'02.09.2019': 6.58,
			'03.09.2019': 6.9,
			'04.09.2019': 7.23,
			'05.09.2019': 7.56,
			'06.09.2019': 7.89,
			'07.09.2019': 8.22,
			'08.09.2019': 8.55,
			'09.09.2019': 8.88,
			'10.09.2019': 9.21,
			'11.09.2019': 9.54,
			'12.09.2019': 0,
			'13.09.2019': 0.33,
			'14.09.2019': 0.66,
			'15.09.2019': 0.99,
			'16.09.2019': 1.32,
			'17.09.2019': 1.65,
			'18.09.2019': 1.97,
			'19.09.2019': 2.3,
			'20.09.2019': 2.63,
			'21.09.2019': 2.96,
			'22.09.2019': 3.29,
			'23.09.2019': 3.62,
			'24.09.2019': 3.95,
			'25.09.2019': 4.27,
			'26.09.2019': 4.6,
			'27.09.2019': 4.93,
			'28.09.2019': 5.26,
			'29.09.2019': 5.59,
			'30.09.2019': 5.92,
			'01.10.2019': 6.25,
			'02.10.2019': 6.58,
			'03.10.2019': 6.9,
			'04.10.2019': 7.23,
			'05.10.2019': 7.56,
			'06.10.2019': 7.89,
			'07.10.2019': 8.22,
			'08.10.2019': 8.55,
			'09.10.2019': 8.88,
			'10.10.2019': 9.21,
			'11.10.2019': 9.54,
			'12.10.2019': 0,
			'13.10.2019': 0.33,
			'14.10.2019': 0.66,
			'15.10.2019': 0.99,
			'16.10.2019': 1.32,
			'17.10.2019': 1.65,
			'18.10.2019': 1.97,
			'19.10.2019': 2.3,
			'20.10.2019': 2.63,
			'21.10.2019': 2.96,
			'22.10.2019': 3.29,
			'23.10.2019': 3.62,
			'24.10.2019': 3.95,
			'25.10.2019': 4.27,
			'26.10.2019': 4.6,
			'27.10.2019': 4.93,
			'28.10.2019': 5.26,
			'29.10.2019': 5.59,
			'30.10.2019': 5.92,
			'31.10.2019': 6.25,
			'01.11.2019': 6.58,
			'02.11.2019': 6.9,
			'03.11.2019': 7.23,
			'04.11.2019': 7.56,
			'05.11.2019': 7.89,
			'06.11.2019': 8.22,
			'07.11.2019': 8.55,
			'08.11.2019': 8.88,
			'09.11.2019': 9.21,
			'10.11.2019': 9.54,
			'11.11.2019': 0,
			'12.11.2019': 0.33,
			'13.11.2019': 0.66,
			'14.11.2019': 0.99,
			'15.11.2019': 1.32,
			'16.11.2019': 1.65,
			'17.11.2019': 1.97,
			'18.11.2019': 2.3,
			'19.11.2019': 2.63,
			'20.11.2019': 2.96,
			'21.11.2019': 3.29,
			'22.11.2019': 3.62,
			'23.11.2019': 3.95,
			'24.11.2019': 4.27,
			'25.11.2019': 4.6,
			'26.11.2019': 4.93,
			'27.11.2019': 5.26,
			'28.11.2019': 5.59,
			'29.11.2019': 5.92,
			'30.11.2019': 6.25,
			'01.12.2019': 6.58,
			'02.12.2019': 6.9,
			'03.12.2019': 7.23,
			'04.12.2019': 7.56,
			'05.12.2019': 7.89,
			'06.12.2019': 8.22,
			'07.12.2019': 8.55,
			'08.12.2019': 8.88,
			'09.12.2019': 9.21,
			'10.12.2019': 9.54,
			'11.12.2019': 0,
			'12.12.2019': 0.33,
			'13.12.2019': 0.66,
			'14.12.2019': 0.99,
			'15.12.2019': 1.32,
			'16.12.2019': 1.65,
			'17.12.2019': 1.97,
			'18.12.2019': 2.3,
			'19.12.2019': 2.63,
			'20.12.2019': 2.96,
			'21.12.2019': 3.29,
			'22.12.2019': 3.62,
			'23.12.2019': 3.95,
			'24.12.2019': 4.27,
			'25.12.2019': 4.6,
			'26.12.2019': 4.93,
			'27.12.2019': 5.26,
			'28.12.2019': 5.59,
			'29.12.2019': 5.92,
			'30.12.2019': 6.25,
			'31.12.2019': 6.58,
			'01.01.2020': 6.9,
			'02.01.2020': 7.23,
			'03.01.2020': 7.56,
			'04.01.2020': 7.89,
			'05.01.2020': 8.22,
			'06.01.2020': 8.55,
			'07.01.2020': 8.88,
			'08.01.2020': 9.21,
			'09.01.2020': 9.54,
			'10.01.2020': 0,
			'11.01.2020': 0.33,
			'12.01.2020': 0.66,
			'13.01.2020': 0.99,
			'14.01.2020': 1.32,
			'15.01.2020': 1.65,
			'16.01.2020': 1.97,
			'17.01.2020': 2.3,
			'18.01.2020': 2.63,
			'19.01.2020': 2.96,
			'20.01.2020': 3.29,
			'21.01.2020': 3.62,
			'22.01.2020': 3.95,
			'23.01.2020': 4.27,
			'24.01.2020': 4.6,
			'25.01.2020': 4.93,
			'26.01.2020': 5.26,
			'27.01.2020': 5.59,
			'28.01.2020': 5.92,
			'29.01.2020': 6.25,
			'30.01.2020': 6.58,
			'31.01.2020': 6.9,
			'01.02.2020': 7.23,
			'02.02.2020': 7.56,
			'03.02.2020': 7.89,
			'04.02.2020': 8.22,
			'05.02.2020': 8.55,
			'06.02.2020': 8.88,
			'07.02.2020': 9.21,
			'08.02.2020': 9.54,
			'09.02.2020': 0,
			'10.02.2020': 0.33,
			'11.02.2020': 0.66,
			'12.02.2020': 0.99,
			'13.02.2020': 1.32,
			'14.02.2020': 1.65,
			'15.02.2020': 1.97,
			'16.02.2020': 2.3,
			'17.02.2020': 2.63,
			'18.02.2020': 2.96,
			'19.02.2020': 3.29,
			'20.02.2020': 3.62,
			'21.02.2020': 3.95,
			'22.02.2020': 4.27,
			'23.02.2020': 4.6,
			'24.02.2020': 4.93,
			'25.02.2020': 5.26,
			'26.02.2020': 5.59,
			'27.02.2020': 5.92,
			'28.02.2020': 6.25,
			'29.02.2020': 6.58,
			'01.03.2020': 6.9,
			'02.03.2020': 7.23,
			'03.03.2020': 7.56,
			'04.03.2020': 7.89,
			'05.03.2020': 8.22,
			'06.03.2020': 8.55,
			'07.03.2020': 8.88,
			'08.03.2020': 9.21,
			'09.03.2020': 9.54,
			'10.03.2020': 0,
			'11.03.2020': 0.33,
			'12.03.2020': 0.66,
			'13.03.2020': 0.99,
			'14.03.2020': 1.32,
			'15.03.2020': 1.65,
			'16.03.2020': 1.97,
			'17.03.2020': 2.3,
			'18.03.2020': 2.63,
			'19.03.2020': 2.96,
			'20.03.2020': 3.29,
			'21.03.2020': 3.62,
			'22.03.2020': 3.95,
			'23.03.2020': 4.27,
			'24.03.2020': 4.6,
			'25.03.2020': 4.93,
			'26.03.2020': 5.26,
			'27.03.2020': 5.59,
			'28.03.2020': 5.92,
			'29.03.2020': 6.25,
			'30.03.2020': 6.58,
			'31.03.2020': 6.9,
			'01.04.2020': 7.23,
			'02.04.2020': 7.56,
			'03.04.2020': 7.89,
			'04.04.2020': 8.22,
			'05.04.2020': 8.55,
			'06.04.2020': 8.88,
			'07.04.2020': 9.21,
			'08.04.2020': 9.54,
			'09.04.2020': 0,
			'10.04.2020': 0.33,
			'11.04.2020': 0.66,
			'12.04.2020': 0.99,
			'13.04.2020': 1.32,
			'14.04.2020': 1.65,
			'15.04.2020': 1.97,
			'16.04.2020': 2.3,
			'17.04.2020': 2.63,
			'18.04.2020': 2.96,
			'19.04.2020': 3.29,
			'20.04.2020': 3.62,
			'21.04.2020': 3.95,
			'22.04.2020': 4.27,
			'23.04.2020': 4.6,
			'24.04.2020': 4.93,
			'25.04.2020': 5.26,
			'26.04.2020': 5.59,
			'27.04.2020': 5.92,
			'28.04.2020': 6.25,
			'29.04.2020': 6.58,
			'30.04.2020': 6.9,
			'01.05.2020': 7.23,
			'02.05.2020': 7.56,
			'03.05.2020': 7.89,
			'04.05.2020': 8.22,
			'05.05.2020': 8.55,
			'06.05.2020': 8.88,
			'07.05.2020': 9.21,
			'08.05.2020': 9.54,
			'09.05.2020': 0,
			'10.05.2020': 0.33,
			'11.05.2020': 0.66,
			'12.05.2020': 0.99,
			'13.05.2020': 1.32,
			'14.05.2020': 1.65,
			'15.05.2020': 1.97,
			'16.05.2020': 2.3,
			'17.05.2020': 2.63,
			'18.05.2020': 2.96,
			'19.05.2020': 3.29,
			'20.05.2020': 3.62,
			'21.05.2020': 3.95,
			'22.05.2020': 4.27,
			'23.05.2020': 4.6,
			'24.05.2020': 4.93,
			'25.05.2020': 5.26,
			'26.05.2020': 5.59,
			'27.05.2020': 5.92,
			'28.05.2020': 6.25,
			'29.05.2020': 6.58,
			'30.05.2020': 6.9,
			'31.05.2020': 7.23,
			'01.06.2020': 7.56,
			'02.06.2020': 7.89,
			'03.06.2020': 8.22,
			'04.06.2020': 8.55,
			'05.06.2020': 8.88,
			'06.06.2020': 9.21,
			'07.06.2020': 9.54,
			'08.06.2020': 0,
			'09.06.2020': 0.33,
			'10.06.2020': 0.66,
			'11.06.2020': 0.99,
			'12.06.2020': 1.32,
			'13.06.2020': 1.65,
			'14.06.2020': 1.97,
			'15.06.2020': 2.3,
			'16.06.2020': 2.63,
			'17.06.2020': 2.96,
			'18.06.2020': 3.29,
			'19.06.2020': 3.62,
			'20.06.2020': 3.95,
			'21.06.2020': 4.27,
			'22.06.2020': 4.6,
			'23.06.2020': 4.93,
			'24.06.2020': 5.26,
			'25.06.2020': 5.59,
			'26.06.2020': 5.92,
			'27.06.2020': 6.25,
			'28.06.2020': 6.58,
			'29.06.2020': 6.9,
			'30.06.2020': 7.23,
			'01.07.2020': 7.56,
			'02.07.2020': 7.89,
			'03.07.2020': 8.22,
			'04.07.2020': 8.55,
			'05.07.2020': 8.88,
			'06.07.2020': 9.21,
			'07.07.2020': 9.54,
			'08.07.2020': 0,
			'09.07.2020': 0.33,
			'10.07.2020': 0.66,
			'11.07.2020': 0.99,
			'12.07.2020': 1.32,
			'13.07.2020': 1.65,
			'14.07.2020': 1.97,
			'15.07.2020': 2.3,
			'16.07.2020': 2.63,
			'17.07.2020': 2.96,
			'18.07.2020': 3.29,
			'19.07.2020': 3.62,
			'20.07.2020': 3.95,
			'21.07.2020': 4.27,
			'22.07.2020': 4.6,
			'23.07.2020': 4.93,
			'24.07.2020': 5.26,
			'25.07.2020': 5.59,
			'26.07.2020': 5.92,
			'27.07.2020': 6.25,
			'28.07.2020': 6.58,
			'29.07.2020': 6.9,
			'30.07.2020': 7.23,
			'31.07.2020': 7.56,
			'01.08.2020': 7.89,
			'02.08.2020': 8.22,
			'03.08.2020': 8.55,
			'04.08.2020': 8.88,
			'05.08.2020': 9.21,
			'06.08.2020': 9.54,
			'07.08.2020': 0,
			'08.08.2020': 0.33,
			'09.08.2020': 0.66,
			'10.08.2020': 0.99,
			'11.08.2020': 1.32,
			'12.08.2020': 1.65,
			'13.08.2020': 1.97,
			'14.08.2020': 2.3,
			'15.08.2020': 2.63,
			'16.08.2020': 2.96,
			'17.08.2020': 3.29,
			'18.08.2020': 3.62,
			'19.08.2020': 3.95,
			'20.08.2020': 4.27,
			'21.08.2020': 4.6,
			'22.08.2020': 4.93,
			'23.08.2020': 5.26,
			'24.08.2020': 5.59,
			'25.08.2020': 5.92,
			'26.08.2020': 6.25,
			'27.08.2020': 6.58,
			'28.08.2020': 6.9,
			'29.08.2020': 7.23,
			'30.08.2020': 7.56,
			'31.08.2020': 7.89,
			'01.09.2020': 8.22,
			'02.09.2020': 8.55,
			'03.09.2020': 8.88,
			'04.09.2020': 9.21,
			'05.09.2020': 9.54,
			'06.09.2020': 0,
			'07.09.2020': 0.33,
			'08.09.2020': 0.66,
			'09.09.2020': 0.99,
			'10.09.2020': 1.32,
			'11.09.2020': 1.65,
			'12.09.2020': 1.97,
			'13.09.2020': 2.3,
			'14.09.2020': 2.63,
			'15.09.2020': 2.96,
			'16.09.2020': 3.29,
			'17.09.2020': 3.62,
			'18.09.2020': 3.95,
			'19.09.2020': 4.27,
			'20.09.2020': 4.6,
			'21.09.2020': 4.93,
			'22.09.2020': 5.26,
			'23.09.2020': 5.59,
			'24.09.2020': 5.92,
			'25.09.2020': 6.25,
			'26.09.2020': 6.58,
			'27.09.2020': 6.9,
			'28.09.2020': 7.23,
			'29.09.2020': 7.56,
			'30.09.2020': 7.89,
			'01.10.2020': 8.22,
			'02.10.2020': 8.55,
			'03.10.2020': 8.88,
			'04.10.2020': 9.21,
			'05.10.2020': 9.54,
			'06.10.2020': 0,
			'07.10.2020': 0.33,
			'08.10.2020': 0.66,
			'09.10.2020': 0.99,
			'10.10.2020': 1.32,
			'11.10.2020': 1.65,
			'12.10.2020': 1.97,
			'13.10.2020': 2.3,
			'14.10.2020': 2.63,
			'15.10.2020': 2.96,
			'16.10.2020': 3.29,
			'17.10.2020': 3.62,
			'18.10.2020': 3.95,
			'19.10.2020': 4.27,
			'20.10.2020': 4.6,
			'21.10.2020': 4.93,
			'22.10.2020': 5.26,
			'23.10.2020': 5.59,
			'24.10.2020': 5.92,
			'25.10.2020': 6.25,
			'26.10.2020': 6.58,
			'27.10.2020': 6.9,
			'28.10.2020': 7.23,
			'29.10.2020': 7.56,
			'30.10.2020': 7.89,
			'31.10.2020': 8.22,
			'01.11.2020': 8.55,
			'02.11.2020': 8.88,
			'03.11.2020': 9.21,
			'04.11.2020': 9.54,
			'05.11.2020': 0,
			'06.11.2020': 0.33,
			'07.11.2020': 0.66,
			'08.11.2020': 0.99,
			'09.11.2020': 1.32,
			'10.11.2020': 1.65,
			'11.11.2020': 1.97,
			'12.11.2020': 2.3,
			'13.11.2020': 2.63,
			'14.11.2020': 2.96,
			'15.11.2020': 3.29,
			'16.11.2020': 3.62,
			'17.11.2020': 3.95,
			'18.11.2020': 4.27,
			'19.11.2020': 4.6,
			'20.11.2020': 4.93,
			'21.11.2020': 5.26,
			'22.11.2020': 5.59,
			'23.11.2020': 5.92,
			'24.11.2020': 6.25,
			'25.11.2020': 6.58,
			'26.11.2020': 6.9,
			'27.11.2020': 7.23,
			'28.11.2020': 7.56,
			'29.11.2020': 7.89,
			'30.11.2020': 8.22,
			'01.12.2020': 8.55,
			'02.12.2020': 8.88,
			'03.12.2020': 9.21,
			'04.12.2020': 9.54,
			'05.12.2020': 0,
			'06.12.2020': 0.33,
			'07.12.2020': 0.66,
			'08.12.2020': 0.99,
			'09.12.2020': 1.32,
			'10.12.2020': 1.65,
			'11.12.2020': 1.97,
			'12.12.2020': 2.3,
			'13.12.2020': 2.63,
			'14.12.2020': 2.96,
			'15.12.2020': 3.29,
			'16.12.2020': 3.62,
			'17.12.2020': 3.95,
			'18.12.2020': 4.27,
			'19.12.2020': 4.6,
			'20.12.2020': 4.93,
			'21.12.2020': 5.26,
			'22.12.2020': 5.59,
			'23.12.2020': 5.92,
			'24.12.2020': 6.25,
			'25.12.2020': 6.58,
			'26.12.2020': 6.9,
			'27.12.2020': 7.23,
			'28.12.2020': 7.56,
			'29.12.2020': 7.89,
			'30.12.2020': 8.22,
			'31.12.2020': 8.55,
			'01.01.2021': 8.88,
			'02.01.2021': 9.21,
			'03.01.2021': 9.54,
			'04.01.2021': 0,
			'05.01.2021': 0.33,
			'06.01.2021': 0.66,
			'07.01.2021': 0.99,
			'08.01.2021': 1.32,
			'09.01.2021': 1.65,
			'10.01.2021': 1.97,
			'11.01.2021': 2.3,
			'12.01.2021': 2.63,
			'13.01.2021': 2.96,
			'14.01.2021': 3.29,
			'15.01.2021': 3.62,
			'16.01.2021': 3.95,
			'17.01.2021': 4.27,
			'18.01.2021': 4.6,
			'19.01.2021': 4.93,
			'20.01.2021': 5.26,
			'21.01.2021': 5.59,
			'22.01.2021': 5.92,
			'23.01.2021': 6.25,
			'24.01.2021': 6.58,
			'25.01.2021': 6.9,
			'26.01.2021': 7.23,
			'27.01.2021': 7.56,
			'28.01.2021': 7.89,
			'29.01.2021': 8.22,
			'30.01.2021': 8.55,
			'31.01.2021': 8.88,
			'01.02.2021': 9.21,
			'02.02.2021': 9.54,
			'03.02.2021': 0,
			'04.02.2021': 0.33,
			'05.02.2021': 0.66,
			'06.02.2021': 0.99,
			'07.02.2021': 1.32,
			'08.02.2021': 1.65,
			'09.02.2021': 1.97,
			'10.02.2021': 2.3,
			'11.02.2021': 2.63,
			'12.02.2021': 2.96,
			'13.02.2021': 3.29,
			'14.02.2021': 3.62,
			'15.02.2021': 3.95,
			'16.02.2021': 4.27,
			'17.02.2021': 4.6,
			'18.02.2021': 4.93,
			'19.02.2021': 5.26,
			'20.02.2021': 5.59,
			'21.02.2021': 5.92,
			'22.02.2021': 6.25,
			'23.02.2021': 6.58,
			'24.02.2021': 6.9,
			'25.02.2021': 7.23,
			'26.02.2021': 7.56,
			'27.02.2021': 7.89,
			'28.02.2021': 8.22,
			'01.03.2021': 8.55,
			'02.03.2021': 8.88,
			'03.03.2021': 9.21,
			'04.03.2021': 9.54,
			'05.03.2021': 0,
			'06.03.2021': 0.33,
			'07.03.2021': 0.66,
			'08.03.2021': 0.99,
			'09.03.2021': 1.32,
			'10.03.2021': 1.65,
			'11.03.2021': 1.97,
			'12.03.2021': 2.3,
			'13.03.2021': 2.63,
			'14.03.2021': 2.96,
			'15.03.2021': 3.29,
			'16.03.2021': 3.62,
			'17.03.2021': 3.95,
			'18.03.2021': 4.27,
			'19.03.2021': 4.6,
			'20.03.2021': 4.93,
			'21.03.2021': 5.26,
			'22.03.2021': 5.59,
			'23.03.2021': 5.92,
			'24.03.2021': 6.25,
			'25.03.2021': 6.58,
			'26.03.2021': 6.9,
			'27.03.2021': 7.23,
			'28.03.2021': 7.56,
			'29.03.2021': 7.89,
			'30.03.2021': 8.22,
			'31.03.2021': 8.55,
			'01.04.2021': 8.88,
			'02.04.2021': 9.21,
			'03.04.2021': 9.54,
			'04.04.2021': 0,
			'05.04.2021': 0.33,
			'06.04.2021': 0.66,
			'07.04.2021': 0.99,
			'08.04.2021': 1.32,
			'09.04.2021': 1.65,
			'10.04.2021': 1.97,
			'11.04.2021': 2.3,
			'12.04.2021': 2.63,
			'13.04.2021': 2.96,
			'14.04.2021': 3.29,
			'15.04.2021': 3.62,
			'16.04.2021': 3.95,
			'17.04.2021': 4.27,
			'18.04.2021': 4.6,
			'19.04.2021': 4.93,
			'20.04.2021': 5.26,
			'21.04.2021': 5.59,
			'22.04.2021': 5.92,
			'23.04.2021': 6.25,
			'24.04.2021': 6.58,
			'25.04.2021': 6.9,
			'26.04.2021': 7.23,
			'27.04.2021': 7.56,
			'28.04.2021': 7.89,
			'29.04.2021': 8.22,
			'30.04.2021': 8.55,
			'01.05.2021': 8.88,
			'02.05.2021': 9.21,
			'03.05.2021': 9.54,
			'04.05.2021': 0,
			'05.05.2021': 0.33,
			'06.05.2021': 0.66,
			'07.05.2021': 0.99,
			'08.05.2021': 1.32,
			'09.05.2021': 1.65,
			'10.05.2021': 1.97,
			'11.05.2021': 2.3,
			'12.05.2021': 2.63,
			'13.05.2021': 2.96,
			'14.05.2021': 3.29,
			'15.05.2021': 3.62,
			'16.05.2021': 3.95,
			'17.05.2021': 4.27,
			'18.05.2021': 4.6,
			'19.05.2021': 4.93,
			'20.05.2021': 5.26,
			'21.05.2021': 5.59,
			'22.05.2021': 5.92,
			'23.05.2021': 6.25,
			'24.05.2021': 6.58,
			'25.05.2021': 6.9,
			'26.05.2021': 7.23,
			'27.05.2021': 7.56,
			'28.05.2021': 7.89,
			'29.05.2021': 8.22,
			'30.05.2021': 8.55,
			'31.05.2021': 8.88,
			'01.06.2021': 9.21,
			'02.06.2021': 9.54,
			'03.06.2021': 0,
			'04.06.2021': 0.33,
			'05.06.2021': 0.66,
			'06.06.2021': 0.99,
			'07.06.2021': 1.32,
			'08.06.2021': 1.65,
			'09.06.2021': 1.97,
			'10.06.2021': 2.3,
			'11.06.2021': 2.63,
			'12.06.2021': 2.96,
			'13.06.2021': 3.29,
			'14.06.2021': 3.62,
			'15.06.2021': 3.95,
			'16.06.2021': 4.27,
			'17.06.2021': 4.6,
			'18.06.2021': 4.93,
			'19.06.2021': 5.26,
			'20.06.2021': 5.59,
			'21.06.2021': 5.92,
			'22.06.2021': 6.25,
			'23.06.2021': 6.58,
			'24.06.2021': 6.9,
			'25.06.2021': 7.23,
			'26.06.2021': 7.56,
			'27.06.2021': 7.89,
			'28.06.2021': 8.22,
			'29.06.2021': 8.55,
			'30.06.2021': 8.88,
			'01.07.2021': 9.21,
			'02.07.2021': 9.54,
			'03.07.2021': 0,
			'04.07.2021': 0.33,
			'05.07.2021': 0.66,
			'06.07.2021': 0.99,
			'07.07.2021': 1.32,
			'08.07.2021': 1.65,
			'09.07.2021': 1.97,
			'10.07.2021': 2.3,
			'11.07.2021': 2.63,
			'12.07.2021': 2.96,
			'13.07.2021': 3.29,
			'14.07.2021': 3.62,
			'15.07.2021': 3.95,
			'16.07.2021': 4.27,
			'17.07.2021': 4.6,
			'18.07.2021': 4.93,
			'19.07.2021': 5.26,
			'20.07.2021': 5.59,
			'21.07.2021': 5.92,
			'22.07.2021': 6.25,
			'23.07.2021': 6.58,
			'24.07.2021': 6.9,
			'25.07.2021': 7.23,
			'26.07.2021': 7.56,
			'27.07.2021': 7.89,
			'28.07.2021': 8.22,
			'29.07.2021': 8.55,
			'30.07.2021': 8.88,
			'31.07.2021': 9.21,
			'01.08.2021': 9.54,
			'02.08.2021': 0,
			'03.08.2021': 0.33,
			'04.08.2021': 0.66,
			'05.08.2021': 0.99,
			'06.08.2021': 1.32,
			'07.08.2021': 1.65,
			'08.08.2021': 1.97,
			'09.08.2021': 2.3,
			'10.08.2021': 2.63,
			'11.08.2021': 2.96,
			'12.08.2021': 3.29,
			'13.08.2021': 3.62,
			'14.08.2021': 3.95,
			'15.08.2021': 4.27,
			'16.08.2021': 4.6,
			'17.08.2021': 4.93,
			'18.08.2021': 5.26,
			'19.08.2021': 5.59,
			'20.08.2021': 5.92,
			'21.08.2021': 6.25,
			'22.08.2021': 6.58,
			'23.08.2021': 6.9,
			'24.08.2021': 7.23,
			'25.08.2021': 7.56,
			'26.08.2021': 7.89,
			'27.08.2021': 8.22,
			'28.08.2021': 8.55,
			'29.08.2021': 8.88,
			'30.08.2021': 9.21,
			'31.08.2021': 9.54,
			'01.09.2021': 0,
			'02.09.2021': 0.33,
			'03.09.2021': 0.66,
			'04.09.2021': 0.99,
			'05.09.2021': 1.32,
			'06.09.2021': 1.65,
			'07.09.2021': 1.97,
			'08.09.2021': 2.3,
			'09.09.2021': 2.63,
			'10.09.2021': 2.96,
			'11.09.2021': 3.29,
			'12.09.2021': 3.62,
			'13.09.2021': 3.95,
			'14.09.2021': 4.27,
			'15.09.2021': 4.6,
			'16.09.2021': 4.93,
			'17.09.2021': 5.26,
			'18.09.2021': 5.59,
			'19.09.2021': 5.92,
			'20.09.2021': 6.25,
			'21.09.2021': 6.58,
			'22.09.2021': 6.9,
			'23.09.2021': 7.23,
			'24.09.2021': 7.56,
			'25.09.2021': 7.89,
			'26.09.2021': 8.22,
			'27.09.2021': 8.55,
			'28.09.2021': 8.88,
			'29.09.2021': 9.21,
			'30.09.2021': 9.54,
			'01.10.2021': 0,
			'02.10.2021': 0.33,
			'03.10.2021': 0.66,
			'04.10.2021': 0.99,
			'05.10.2021': 1.32,
			'06.10.2021': 1.65,
			'07.10.2021': 1.97,
			'08.10.2021': 2.3,
			'09.10.2021': 2.63,
			'10.10.2021': 2.96,
			'11.10.2021': 3.29,
			'12.10.2021': 3.62,
			'13.10.2021': 3.95,
			'14.10.2021': 4.27,
			'15.10.2021': 4.6,
			'16.10.2021': 4.93,
			'17.10.2021': 5.26,
			'18.10.2021': 5.59,
			'19.10.2021': 5.92,
			'20.10.2021': 6.25,
			'21.10.2021': 6.58,
			'22.10.2021': 6.9,
			'23.10.2021': 7.23,
			'24.10.2021': 7.56,
			'25.10.2021': 7.89,
			'26.10.2021': 8.22,
			'27.10.2021': 8.55,
			'28.10.2021': 8.88,
			'29.10.2021': 9.21,
			'30.10.2021': 9.54,
			'31.10.2021': 0,
			'01.11.2021': 0.33,
			'02.11.2021': 0.66,
			'03.11.2021': 0.99,
			'04.11.2021': 1.32,
			'05.11.2021': 1.65,
			'06.11.2021': 1.97,
			'07.11.2021': 2.3,
			'08.11.2021': 2.63,
			'09.11.2021': 2.96,
			'10.11.2021': 3.29,
			'11.11.2021': 3.62,
			'12.11.2021': 3.95,
			'13.11.2021': 4.27,
			'14.11.2021': 4.6,
			'15.11.2021': 4.93,
			'16.11.2021': 5.26,
			'17.11.2021': 5.59,
			'18.11.2021': 5.92,
			'19.11.2021': 6.25,
			'20.11.2021': 6.58,
			'21.11.2021': 6.9,
			'22.11.2021': 7.23,
			'23.11.2021': 7.56,
			'24.11.2021': 7.89,
			'25.11.2021': 8.22,
			'26.11.2021': 8.55,
			'27.11.2021': 8.88,
			'28.11.2021': 9.21,
			'29.11.2021': 9.54,
			'30.11.2021': 0,
			'01.12.2021': 0.33,
			'02.12.2021': 0.66,
			'03.12.2021': 0.99,
			'04.12.2021': 1.32,
			'05.12.2021': 1.65,
			'06.12.2021': 1.97,
			'07.12.2021': 2.3,
			'08.12.2021': 2.63,
			'09.12.2021': 2.96,
			'10.12.2021': 3.29,
			'11.12.2021': 3.62,
			'12.12.2021': 3.95,
			'13.12.2021': 4.27,
			'14.12.2021': 4.6,
			'15.12.2021': 4.93,
			'16.12.2021': 5.26,
			'17.12.2021': 5.59,
			'18.12.2021': 5.92,
			'19.12.2021': 6.25,
			'20.12.2021': 6.58,
			'21.12.2021': 6.9,
			'22.12.2021': 7.23,
			'23.12.2021': 7.56,
			'24.12.2021': 7.89,
			'25.12.2021': 8.22,
			'26.12.2021': 8.55,
			'27.12.2021': 8.88,
			'28.12.2021': 9.21,
			'29.12.2021': 9.54,
			'30.12.2021': 0,
			'31.12.2021': 0.33,
			'01.01.2022': 0.66,
			'02.01.2022': 0.99,
			'03.01.2022': 1.32,
			'04.01.2022': 1.65,
			'05.01.2022': 1.97,
			'06.01.2022': 2.3,
			'07.01.2022': 2.63,
			'08.01.2022': 2.96,
			'09.01.2022': 3.29,
			'10.01.2022': 3.62,
			'11.01.2022': 3.95,
			'12.01.2022': 4.27,
			'13.01.2022': 4.6,
			'14.01.2022': 4.93,
			'15.01.2022': 5.26,
			'16.01.2022': 5.59,
			'17.01.2022': 5.92,
			'18.01.2022': 6.25,
			'19.01.2022': 6.58,
			'20.01.2022': 6.9,
			'21.01.2022': 7.23,
			'22.01.2022': 7.56,
			'23.01.2022': 7.89,
			'24.01.2022': 8.22,
			'25.01.2022': 8.55,
			'26.01.2022': 8.88,
			'27.01.2022': 9.21,
			'28.01.2022': 9.54,
			'29.01.2022': 0
		}
	},
	'2P1': {
		keyMoex: null,
		values: {
			'27.08.2020': 0,
			'28.08.2020': 0.27,
			'29.08.2020': 0.55,
			'30.08.2020': 0.82,
			'31.08.2020': 1.1,
			'01.09.2020': 1.37,
			'02.09.2020': 1.64,
			'03.09.2020': 1.92,
			'04.09.2020': 2.19,
			'05.09.2020': 2.47,
			'06.09.2020': 2.74,
			'07.09.2020': 3.01,
			'08.09.2020': 3.29,
			'09.09.2020': 3.56,
			'10.09.2020': 3.84,
			'11.09.2020': 4.11,
			'12.09.2020': 4.38,
			'13.09.2020': 4.66,
			'14.09.2020': 4.93,
			'15.09.2020': 5.21,
			'16.09.2020': 5.48,
			'17.09.2020': 5.75,
			'18.09.2020': 6.03,
			'19.09.2020': 6.3,
			'20.09.2020': 6.58,
			'21.09.2020': 6.85,
			'22.09.2020': 7.12,
			'23.09.2020': 7.4,
			'24.09.2020': 7.67,
			'25.09.2020': 7.95,
			'26.09.2020': 0,
			'27.09.2020': 0.27,
			'28.09.2020': 0.55,
			'29.09.2020': 0.82,
			'30.09.2020': 1.1,
			'01.10.2020': 1.37,
			'02.10.2020': 1.64,
			'03.10.2020': 1.92,
			'04.10.2020': 2.19,
			'05.10.2020': 2.47,
			'06.10.2020': 2.74,
			'07.10.2020': 3.01,
			'08.10.2020': 3.29,
			'09.10.2020': 3.56,
			'10.10.2020': 3.84,
			'11.10.2020': 4.11,
			'12.10.2020': 4.38,
			'13.10.2020': 4.66,
			'14.10.2020': 4.93,
			'15.10.2020': 5.21,
			'16.10.2020': 5.48,
			'17.10.2020': 5.75,
			'18.10.2020': 6.03,
			'19.10.2020': 6.3,
			'20.10.2020': 6.58,
			'21.10.2020': 6.85,
			'22.10.2020': 7.12,
			'23.10.2020': 7.4,
			'24.10.2020': 7.67,
			'25.10.2020': 7.95,
			'26.10.2020': 0,
			'27.10.2020': 0.27,
			'28.10.2020': 0.55,
			'29.10.2020': 0.82,
			'30.10.2020': 1.1,
			'31.10.2020': 1.37,
			'01.11.2020': 1.64,
			'02.11.2020': 1.92,
			'03.11.2020': 2.19,
			'04.11.2020': 2.47,
			'05.11.2020': 2.74,
			'06.11.2020': 3.01,
			'07.11.2020': 3.29,
			'08.11.2020': 3.56,
			'09.11.2020': 3.84,
			'10.11.2020': 4.11,
			'11.11.2020': 4.38,
			'12.11.2020': 4.66,
			'13.11.2020': 4.93,
			'14.11.2020': 5.21,
			'15.11.2020': 5.48,
			'16.11.2020': 5.75,
			'17.11.2020': 6.03,
			'18.11.2020': 6.3,
			'19.11.2020': 6.58,
			'20.11.2020': 6.85,
			'21.11.2020': 7.12,
			'22.11.2020': 7.4,
			'23.11.2020': 7.67,
			'24.11.2020': 7.95,
			'25.11.2020': 0,
			'26.11.2020': 0.27,
			'27.11.2020': 0.55,
			'28.11.2020': 0.82,
			'29.11.2020': 1.1,
			'30.11.2020': 1.37,
			'01.12.2020': 1.64,
			'02.12.2020': 1.92,
			'03.12.2020': 2.19,
			'04.12.2020': 2.47,
			'05.12.2020': 2.74,
			'06.12.2020': 3.01,
			'07.12.2020': 3.29,
			'08.12.2020': 3.56,
			'09.12.2020': 3.84,
			'10.12.2020': 4.11,
			'11.12.2020': 4.38,
			'12.12.2020': 4.66,
			'13.12.2020': 4.93,
			'14.12.2020': 5.21,
			'15.12.2020': 5.48,
			'16.12.2020': 5.75,
			'17.12.2020': 6.03,
			'18.12.2020': 6.3,
			'19.12.2020': 6.58,
			'20.12.2020': 6.85,
			'21.12.2020': 7.12,
			'22.12.2020': 7.4,
			'23.12.2020': 7.67,
			'24.12.2020': 7.95,
			'25.12.2020': 0,
			'26.12.2020': 0.27,
			'27.12.2020': 0.55,
			'28.12.2020': 0.82,
			'29.12.2020': 1.1,
			'30.12.2020': 1.37,
			'31.12.2020': 1.64,
			'01.01.2021': 1.92,
			'02.01.2021': 2.19,
			'03.01.2021': 2.47,
			'04.01.2021': 2.74,
			'05.01.2021': 3.01,
			'06.01.2021': 3.29,
			'07.01.2021': 3.56,
			'08.01.2021': 3.84,
			'09.01.2021': 4.11,
			'10.01.2021': 4.38,
			'11.01.2021': 4.66,
			'12.01.2021': 4.93,
			'13.01.2021': 5.21,
			'14.01.2021': 5.48,
			'15.01.2021': 5.75,
			'16.01.2021': 6.03,
			'17.01.2021': 6.3,
			'18.01.2021': 6.58,
			'19.01.2021': 6.85,
			'20.01.2021': 7.12,
			'21.01.2021': 7.4,
			'22.01.2021': 7.67,
			'23.01.2021': 7.95,
			'24.01.2021': 0,
			'25.01.2021': 0.27,
			'26.01.2021': 0.55,
			'27.01.2021': 0.82,
			'28.01.2021': 1.1,
			'29.01.2021': 1.37,
			'30.01.2021': 1.64,
			'31.01.2021': 1.92,
			'01.02.2021': 2.19,
			'02.02.2021': 2.47,
			'03.02.2021': 2.74,
			'04.02.2021': 3.01,
			'05.02.2021': 3.29,
			'06.02.2021': 3.56,
			'07.02.2021': 3.84,
			'08.02.2021': 4.11,
			'09.02.2021': 4.38,
			'10.02.2021': 4.66,
			'11.02.2021': 4.93,
			'12.02.2021': 5.21,
			'13.02.2021': 5.48,
			'14.02.2021': 5.75,
			'15.02.2021': 6.03,
			'16.02.2021': 6.3,
			'17.02.2021': 6.58,
			'18.02.2021': 6.85,
			'19.02.2021': 7.12,
			'20.02.2021': 7.4,
			'21.02.2021': 7.67,
			'22.02.2021': 7.95,
			'23.02.2021': 0,
			'24.02.2021': 0.27,
			'25.02.2021': 0.55,
			'26.02.2021': 0.82,
			'27.02.2021': 1.1,
			'28.02.2021': 1.37,
			'01.03.2021': 1.64,
			'02.03.2021': 1.92,
			'03.03.2021': 2.19,
			'04.03.2021': 2.47,
			'05.03.2021': 2.74,
			'06.03.2021': 3.01,
			'07.03.2021': 3.29,
			'08.03.2021': 3.56,
			'09.03.2021': 3.84,
			'10.03.2021': 4.11,
			'11.03.2021': 4.38,
			'12.03.2021': 4.66,
			'13.03.2021': 4.93,
			'14.03.2021': 5.21,
			'15.03.2021': 5.48,
			'16.03.2021': 5.75,
			'17.03.2021': 6.03,
			'18.03.2021': 6.3,
			'19.03.2021': 6.58,
			'20.03.2021': 6.85,
			'21.03.2021': 7.12,
			'22.03.2021': 7.4,
			'23.03.2021': 7.67,
			'24.03.2021': 7.95,
			'25.03.2021': 0,
			'26.03.2021': 0.27,
			'27.03.2021': 0.55,
			'28.03.2021': 0.82,
			'29.03.2021': 1.1,
			'30.03.2021': 1.37,
			'31.03.2021': 1.64,
			'01.04.2021': 1.92,
			'02.04.2021': 2.19,
			'03.04.2021': 2.47,
			'04.04.2021': 2.74,
			'05.04.2021': 3.01,
			'06.04.2021': 3.29,
			'07.04.2021': 3.56,
			'08.04.2021': 3.84,
			'09.04.2021': 4.11,
			'10.04.2021': 4.38,
			'11.04.2021': 4.66,
			'12.04.2021': 4.93,
			'13.04.2021': 5.21,
			'14.04.2021': 5.48,
			'15.04.2021': 5.75,
			'16.04.2021': 6.03,
			'17.04.2021': 6.3,
			'18.04.2021': 6.58,
			'19.04.2021': 6.85,
			'20.04.2021': 7.12,
			'21.04.2021': 7.4,
			'22.04.2021': 7.67,
			'23.04.2021': 7.95,
			'24.04.2021': 0,
			'25.04.2021': 0.27,
			'26.04.2021': 0.55,
			'27.04.2021': 0.82,
			'28.04.2021': 1.1,
			'29.04.2021': 1.37,
			'30.04.2021': 1.64,
			'01.05.2021': 1.92,
			'02.05.2021': 2.19,
			'03.05.2021': 2.47,
			'04.05.2021': 2.74,
			'05.05.2021': 3.01,
			'06.05.2021': 3.29,
			'07.05.2021': 3.56,
			'08.05.2021': 3.84,
			'09.05.2021': 4.11,
			'10.05.2021': 4.38,
			'11.05.2021': 4.66,
			'12.05.2021': 4.93,
			'13.05.2021': 5.21,
			'14.05.2021': 5.48,
			'15.05.2021': 5.75,
			'16.05.2021': 6.03,
			'17.05.2021': 6.3,
			'18.05.2021': 6.58,
			'19.05.2021': 6.85,
			'20.05.2021': 7.12,
			'21.05.2021': 7.4,
			'22.05.2021': 7.67,
			'23.05.2021': 7.95,
			'24.05.2021': 0,
			'25.05.2021': 0.27,
			'26.05.2021': 0.55,
			'27.05.2021': 0.82,
			'28.05.2021': 1.1,
			'29.05.2021': 1.37,
			'30.05.2021': 1.64,
			'31.05.2021': 1.92,
			'01.06.2021': 2.19,
			'02.06.2021': 2.47,
			'03.06.2021': 2.74,
			'04.06.2021': 3.01,
			'05.06.2021': 3.29,
			'06.06.2021': 3.56,
			'07.06.2021': 3.84,
			'08.06.2021': 4.11,
			'09.06.2021': 4.38,
			'10.06.2021': 4.66,
			'11.06.2021': 4.93,
			'12.06.2021': 5.21,
			'13.06.2021': 5.48,
			'14.06.2021': 5.75,
			'15.06.2021': 6.03,
			'16.06.2021': 6.3,
			'17.06.2021': 6.58,
			'18.06.2021': 6.85,
			'19.06.2021': 7.12,
			'20.06.2021': 7.4,
			'21.06.2021': 7.67,
			'22.06.2021': 7.95,
			'23.06.2021': 0,
			'24.06.2021': 0.27,
			'25.06.2021': 0.55,
			'26.06.2021': 0.82,
			'27.06.2021': 1.1,
			'28.06.2021': 1.37,
			'29.06.2021': 1.64,
			'30.06.2021': 1.92,
			'01.07.2021': 2.19,
			'02.07.2021': 2.47,
			'03.07.2021': 2.74,
			'04.07.2021': 3.01,
			'05.07.2021': 3.29,
			'06.07.2021': 3.56,
			'07.07.2021': 3.84,
			'08.07.2021': 4.11,
			'09.07.2021': 4.38,
			'10.07.2021': 4.66,
			'11.07.2021': 4.93,
			'12.07.2021': 5.21,
			'13.07.2021': 5.48,
			'14.07.2021': 5.75,
			'15.07.2021': 6.03,
			'16.07.2021': 6.3,
			'17.07.2021': 6.58,
			'18.07.2021': 6.85,
			'19.07.2021': 7.12,
			'20.07.2021': 7.4,
			'21.07.2021': 7.67,
			'22.07.2021': 7.95,
			'23.07.2021': 0,
			'24.07.2021': 0.27,
			'25.07.2021': 0.55,
			'26.07.2021': 0.82,
			'27.07.2021': 1.1,
			'28.07.2021': 1.37,
			'29.07.2021': 1.64,
			'30.07.2021': 1.92,
			'31.07.2021': 2.19,
			'01.08.2021': 2.47,
			'02.08.2021': 2.74,
			'03.08.2021': 3.01,
			'04.08.2021': 3.29,
			'05.08.2021': 3.56,
			'06.08.2021': 3.84,
			'07.08.2021': 4.11,
			'08.08.2021': 4.38,
			'09.08.2021': 4.66,
			'10.08.2021': 4.93,
			'11.08.2021': 5.21,
			'12.08.2021': 5.48,
			'13.08.2021': 5.75,
			'14.08.2021': 6.03,
			'15.08.2021': 6.3,
			'16.08.2021': 6.58,
			'17.08.2021': 6.85,
			'18.08.2021': 7.12,
			'19.08.2021': 7.4,
			'20.08.2021': 7.67,
			'21.08.2021': 7.95,
			'22.08.2021': 0,
			'23.08.2021': 0.27,
			'24.08.2021': 0.55,
			'25.08.2021': 0.82,
			'26.08.2021': 1.1,
			'27.08.2021': 1.37,
			'28.08.2021': 1.64,
			'29.08.2021': 1.92,
			'30.08.2021': 2.19,
			'31.08.2021': 2.47,
			'01.09.2021': 2.74,
			'02.09.2021': 3.01,
			'03.09.2021': 3.29,
			'04.09.2021': 3.56,
			'05.09.2021': 3.84,
			'06.09.2021': 4.11,
			'07.09.2021': 4.38,
			'08.09.2021': 4.66,
			'09.09.2021': 4.93,
			'10.09.2021': 5.21,
			'11.09.2021': 5.48,
			'12.09.2021': 5.75,
			'13.09.2021': 6.03,
			'14.09.2021': 6.3,
			'15.09.2021': 6.58,
			'16.09.2021': 6.85,
			'17.09.2021': 7.12,
			'18.09.2021': 7.4,
			'19.09.2021': 7.67,
			'20.09.2021': 7.95,
			'21.09.2021': 0,
			'22.09.2021': 0.27,
			'23.09.2021': 0.55,
			'24.09.2021': 0.82,
			'25.09.2021': 1.1,
			'26.09.2021': 1.37,
			'27.09.2021': 1.64,
			'28.09.2021': 1.92,
			'29.09.2021': 2.19,
			'30.09.2021': 2.47,
			'01.10.2021': 2.74,
			'02.10.2021': 3.01,
			'03.10.2021': 3.29,
			'04.10.2021': 3.56,
			'05.10.2021': 3.84,
			'06.10.2021': 4.11,
			'07.10.2021': 4.38,
			'08.10.2021': 4.66,
			'09.10.2021': 4.93,
			'10.10.2021': 5.21,
			'11.10.2021': 5.48,
			'12.10.2021': 5.75,
			'13.10.2021': 6.03,
			'14.10.2021': 6.3,
			'15.10.2021': 6.58,
			'16.10.2021': 6.85,
			'17.10.2021': 7.12,
			'18.10.2021': 7.4,
			'19.10.2021': 7.67,
			'20.10.2021': 7.95,
			'21.10.2021': 0,
			'22.10.2021': 0.27,
			'23.10.2021': 0.55,
			'24.10.2021': 0.82,
			'25.10.2021': 1.1,
			'26.10.2021': 1.37,
			'27.10.2021': 1.64,
			'28.10.2021': 1.92,
			'29.10.2021': 2.19,
			'30.10.2021': 2.47,
			'31.10.2021': 2.74,
			'01.11.2021': 3.01,
			'02.11.2021': 3.29,
			'03.11.2021': 3.56,
			'04.11.2021': 3.84,
			'05.11.2021': 4.11,
			'06.11.2021': 4.38,
			'07.11.2021': 4.66,
			'08.11.2021': 4.93,
			'09.11.2021': 5.21,
			'10.11.2021': 5.48,
			'11.11.2021': 5.75,
			'12.11.2021': 6.03,
			'13.11.2021': 6.3,
			'14.11.2021': 6.58,
			'15.11.2021': 6.85,
			'16.11.2021': 7.12,
			'17.11.2021': 7.4,
			'18.11.2021': 7.67,
			'19.11.2021': 7.95,
			'20.11.2021': 0,
			'21.11.2021': 0.27,
			'22.11.2021': 0.55,
			'23.11.2021': 0.82,
			'24.11.2021': 1.1,
			'25.11.2021': 1.37,
			'26.11.2021': 1.64,
			'27.11.2021': 1.92,
			'28.11.2021': 2.19,
			'29.11.2021': 2.47,
			'30.11.2021': 2.74,
			'01.12.2021': 3.01,
			'02.12.2021': 3.29,
			'03.12.2021': 3.56,
			'04.12.2021': 3.84,
			'05.12.2021': 4.11,
			'06.12.2021': 4.38,
			'07.12.2021': 4.66,
			'08.12.2021': 4.93,
			'09.12.2021': 5.21,
			'10.12.2021': 5.48,
			'11.12.2021': 5.75,
			'12.12.2021': 6.03,
			'13.12.2021': 6.3,
			'14.12.2021': 6.58,
			'15.12.2021': 6.85,
			'16.12.2021': 7.12,
			'17.12.2021': 7.4,
			'18.12.2021': 7.67,
			'19.12.2021': 7.95,
			'20.12.2021': 0,
			'21.12.2021': 0.27,
			'22.12.2021': 0.55,
			'23.12.2021': 0.82,
			'24.12.2021': 1.1,
			'25.12.2021': 1.37,
			'26.12.2021': 1.64,
			'27.12.2021': 1.92,
			'28.12.2021': 2.19,
			'29.12.2021': 2.47,
			'30.12.2021': 2.74,
			'31.12.2021': 3.01,
			'01.01.2022': 3.29,
			'02.01.2022': 3.56,
			'03.01.2022': 3.84,
			'04.01.2022': 4.11,
			'05.01.2022': 4.38,
			'06.01.2022': 4.66,
			'07.01.2022': 4.93,
			'08.01.2022': 5.21,
			'09.01.2022': 5.48,
			'10.01.2022': 5.75,
			'11.01.2022': 6.03,
			'12.01.2022': 6.3,
			'13.01.2022': 6.58,
			'14.01.2022': 6.85,
			'15.01.2022': 7.12,
			'16.01.2022': 7.4,
			'17.01.2022': 7.67,
			'18.01.2022': 7.95,
			'19.01.2022': 0,
			'20.01.2022': 0.27,
			'21.01.2022': 0.55,
			'22.01.2022': 0.82,
			'23.01.2022': 1.1,
			'24.01.2022': 1.37,
			'25.01.2022': 1.64,
			'26.01.2022': 1.92,
			'27.01.2022': 2.19,
			'28.01.2022': 2.47,
			'29.01.2022': 2.74,
			'30.01.2022': 3.01,
			'31.01.2022': 3.29,
			'01.02.2022': 3.56,
			'02.02.2022': 3.84,
			'03.02.2022': 4.11,
			'04.02.2022': 4.38,
			'05.02.2022': 4.66,
			'06.02.2022': 4.93,
			'07.02.2022': 5.21,
			'08.02.2022': 5.48,
			'09.02.2022': 5.75,
			'10.02.2022': 6.03,
			'11.02.2022': 6.3,
			'12.02.2022': 6.58,
			'13.02.2022': 6.85,
			'14.02.2022': 7.12,
			'15.02.2022': 7.4,
			'16.02.2022': 7.67,
			'17.02.2022': 7.95,
			'18.02.2022': 0,
			'19.02.2022': 0.27,
			'20.02.2022': 0.55,
			'21.02.2022': 0.82,
			'22.02.2022': 1.1,
			'23.02.2022': 1.37,
			'24.02.2022': 1.64,
			'25.02.2022': 1.92,
			'26.02.2022': 2.19,
			'27.02.2022': 2.47,
			'28.02.2022': 2.74,
			'01.03.2022': 3.01,
			'02.03.2022': 3.29,
			'03.03.2022': 3.56,
			'04.03.2022': 3.84,
			'05.03.2022': 4.11,
			'06.03.2022': 4.38,
			'07.03.2022': 4.66,
			'08.03.2022': 4.93,
			'09.03.2022': 5.21,
			'10.03.2022': 5.48,
			'11.03.2022': 5.75,
			'12.03.2022': 6.03,
			'13.03.2022': 6.3,
			'14.03.2022': 6.58,
			'15.03.2022': 6.85,
			'16.03.2022': 7.12,
			'17.03.2022': 7.4,
			'18.03.2022': 7.67,
			'19.03.2022': 7.95,
			'20.03.2022': 0,
			'21.03.2022': 0.27,
			'22.03.2022': 0.55,
			'23.03.2022': 0.82,
			'24.03.2022': 1.1,
			'25.03.2022': 1.37,
			'26.03.2022': 1.64,
			'27.03.2022': 1.92,
			'28.03.2022': 2.19,
			'29.03.2022': 2.47,
			'30.03.2022': 2.74,
			'31.03.2022': 3.01,
			'01.04.2022': 3.29,
			'02.04.2022': 3.56,
			'03.04.2022': 3.84,
			'04.04.2022': 4.11,
			'05.04.2022': 4.38,
			'06.04.2022': 4.66,
			'07.04.2022': 4.93,
			'08.04.2022': 5.21,
			'09.04.2022': 5.48,
			'10.04.2022': 5.75,
			'11.04.2022': 6.03,
			'12.04.2022': 6.3,
			'13.04.2022': 6.58,
			'14.04.2022': 6.85,
			'15.04.2022': 7.12,
			'16.04.2022': 7.4,
			'17.04.2022': 7.67,
			'18.04.2022': 7.95,
			'19.04.2022': 0,
			'20.04.2022': 0.27,
			'21.04.2022': 0.55,
			'22.04.2022': 0.82,
			'23.04.2022': 1.1,
			'24.04.2022': 1.37,
			'25.04.2022': 1.64,
			'26.04.2022': 1.92,
			'27.04.2022': 2.19,
			'28.04.2022': 2.47,
			'29.04.2022': 2.74,
			'30.04.2022': 3.01,
			'01.05.2022': 3.29,
			'02.05.2022': 3.56,
			'03.05.2022': 3.84,
			'04.05.2022': 4.11,
			'05.05.2022': 4.38,
			'06.05.2022': 4.66,
			'07.05.2022': 4.93,
			'08.05.2022': 5.21,
			'09.05.2022': 5.48,
			'10.05.2022': 5.75,
			'11.05.2022': 6.03,
			'12.05.2022': 6.3,
			'13.05.2022': 6.58,
			'14.05.2022': 6.85,
			'15.05.2022': 7.12,
			'16.05.2022': 7.4,
			'17.05.2022': 7.67,
			'18.05.2022': 7.95,
			'19.05.2022': 0,
			'20.05.2022': 0.27,
			'21.05.2022': 0.55,
			'22.05.2022': 0.82,
			'23.05.2022': 1.1,
			'24.05.2022': 1.37,
			'25.05.2022': 1.64,
			'26.05.2022': 1.92,
			'27.05.2022': 2.19,
			'28.05.2022': 2.47,
			'29.05.2022': 2.74,
			'30.05.2022': 3.01,
			'31.05.2022': 3.29,
			'01.06.2022': 3.56,
			'02.06.2022': 3.84,
			'03.06.2022': 4.11,
			'04.06.2022': 4.38,
			'05.06.2022': 4.66,
			'06.06.2022': 4.93,
			'07.06.2022': 5.21,
			'08.06.2022': 5.48,
			'09.06.2022': 5.75,
			'10.06.2022': 6.03,
			'11.06.2022': 6.3,
			'12.06.2022': 6.58,
			'13.06.2022': 6.85,
			'14.06.2022': 7.12,
			'15.06.2022': 7.4,
			'16.06.2022': 7.67,
			'17.06.2022': 7.95,
			'18.06.2022': 0,
			'19.06.2022': 0.27,
			'20.06.2022': 0.55,
			'21.06.2022': 0.82,
			'22.06.2022': 1.1,
			'23.06.2022': 1.37,
			'24.06.2022': 1.64,
			'25.06.2022': 1.92,
			'26.06.2022': 2.19,
			'27.06.2022': 2.47,
			'28.06.2022': 2.74,
			'29.06.2022': 3.01,
			'30.06.2022': 3.29,
			'01.07.2022': 3.56,
			'02.07.2022': 3.84,
			'03.07.2022': 4.11,
			'04.07.2022': 4.38,
			'05.07.2022': 4.66,
			'06.07.2022': 4.93,
			'07.07.2022': 5.21,
			'08.07.2022': 5.48,
			'09.07.2022': 5.75,
			'10.07.2022': 6.03,
			'11.07.2022': 6.3,
			'12.07.2022': 6.58,
			'13.07.2022': 6.85,
			'14.07.2022': 7.12,
			'15.07.2022': 7.4,
			'16.07.2022': 7.67,
			'17.07.2022': 7.95,
			'18.07.2022': 0,
			'19.07.2022': 0.27,
			'20.07.2022': 0.55,
			'21.07.2022': 0.82,
			'22.07.2022': 1.1,
			'23.07.2022': 1.37,
			'24.07.2022': 1.64,
			'25.07.2022': 1.92,
			'26.07.2022': 2.19,
			'27.07.2022': 2.47,
			'28.07.2022': 2.74,
			'29.07.2022': 3.01,
			'30.07.2022': 3.29,
			'31.07.2022': 3.56,
			'01.08.2022': 3.84,
			'02.08.2022': 4.11,
			'03.08.2022': 4.38,
			'04.08.2022': 4.66,
			'05.08.2022': 4.93,
			'06.08.2022': 5.21,
			'07.08.2022': 5.48,
			'08.08.2022': 5.75,
			'09.08.2022': 6.03,
			'10.08.2022': 6.3,
			'11.08.2022': 6.58,
			'12.08.2022': 6.85,
			'13.08.2022': 7.12,
			'14.08.2022': 7.4,
			'15.08.2022': 7.67,
			'16.08.2022': 7.95,
			'17.08.2022': 0,
			'18.08.2022': 0.27,
			'19.08.2022': 0.55,
			'20.08.2022': 0.82,
			'21.08.2022': 1.1,
			'22.08.2022': 1.37,
			'23.08.2022': 1.64,
			'24.08.2022': 1.92,
			'25.08.2022': 2.19,
			'26.08.2022': 2.47,
			'27.08.2022': 2.74,
			'28.08.2022': 3.01,
			'29.08.2022': 3.29,
			'30.08.2022': 3.56,
			'31.08.2022': 3.84,
			'01.09.2022': 4.11,
			'02.09.2022': 4.38,
			'03.09.2022': 4.66,
			'04.09.2022': 4.93,
			'05.09.2022': 5.21,
			'06.09.2022': 5.48,
			'07.09.2022': 5.75,
			'08.09.2022': 6.03,
			'09.09.2022': 6.3,
			'10.09.2022': 6.58,
			'11.09.2022': 6.85,
			'12.09.2022': 7.12,
			'13.09.2022': 7.4,
			'14.09.2022': 7.67,
			'15.09.2022': 7.95,
			'16.09.2022': 0,
			'17.09.2022': 0.27,
			'18.09.2022': 0.55,
			'19.09.2022': 0.82,
			'20.09.2022': 1.1,
			'21.09.2022': 1.37,
			'22.09.2022': 1.64,
			'23.09.2022': 1.92,
			'24.09.2022': 2.19,
			'25.09.2022': 2.47,
			'26.09.2022': 2.74,
			'27.09.2022': 3.01,
			'28.09.2022': 3.29,
			'29.09.2022': 3.56,
			'30.09.2022': 3.84,
			'01.10.2022': 4.11,
			'02.10.2022': 4.38,
			'03.10.2022': 4.66,
			'04.10.2022': 4.93,
			'05.10.2022': 5.21,
			'06.10.2022': 5.48,
			'07.10.2022': 5.75,
			'08.10.2022': 6.03,
			'09.10.2022': 6.3,
			'10.10.2022': 6.58,
			'11.10.2022': 6.85,
			'12.10.2022': 7.12,
			'13.10.2022': 7.4,
			'14.10.2022': 7.67,
			'15.10.2022': 7.95,
			'16.10.2022': 0,
			'17.10.2022': 0.27,
			'18.10.2022': 0.55,
			'19.10.2022': 0.82,
			'20.10.2022': 1.1,
			'21.10.2022': 1.37,
			'22.10.2022': 1.64,
			'23.10.2022': 1.92,
			'24.10.2022': 2.19,
			'25.10.2022': 2.47,
			'26.10.2022': 2.74,
			'27.10.2022': 3.01,
			'28.10.2022': 3.29,
			'29.10.2022': 3.56,
			'30.10.2022': 3.84,
			'31.10.2022': 4.11,
			'01.11.2022': 4.38,
			'02.11.2022': 4.66,
			'03.11.2022': 4.93,
			'04.11.2022': 5.21,
			'05.11.2022': 5.48,
			'06.11.2022': 5.75,
			'07.11.2022': 6.03,
			'08.11.2022': 6.3,
			'09.11.2022': 6.58,
			'10.11.2022': 6.85,
			'11.11.2022': 7.12,
			'12.11.2022': 7.4,
			'13.11.2022': 7.67,
			'14.11.2022': 7.95,
			'15.11.2022': 0,
			'16.11.2022': 0.27,
			'17.11.2022': 0.55,
			'18.11.2022': 0.82,
			'19.11.2022': 1.1,
			'20.11.2022': 1.37,
			'21.11.2022': 1.64,
			'22.11.2022': 1.92,
			'23.11.2022': 2.19,
			'24.11.2022': 2.47,
			'25.11.2022': 2.74,
			'26.11.2022': 3.01,
			'27.11.2022': 3.29,
			'28.11.2022': 3.56,
			'29.11.2022': 3.84,
			'30.11.2022': 4.11,
			'01.12.2022': 4.38,
			'02.12.2022': 4.66,
			'03.12.2022': 4.93,
			'04.12.2022': 5.21,
			'05.12.2022': 5.48,
			'06.12.2022': 5.75,
			'07.12.2022': 6.03,
			'08.12.2022': 6.3,
			'09.12.2022': 6.58,
			'10.12.2022': 6.85,
			'11.12.2022': 7.12,
			'12.12.2022': 7.4,
			'13.12.2022': 7.67,
			'14.12.2022': 7.95,
			'15.12.2022': 0,
			'16.12.2022': 0.27,
			'17.12.2022': 0.55,
			'18.12.2022': 0.82,
			'19.12.2022': 1.1,
			'20.12.2022': 1.37,
			'21.12.2022': 1.64,
			'22.12.2022': 1.92,
			'23.12.2022': 2.19,
			'24.12.2022': 2.47,
			'25.12.2022': 2.74,
			'26.12.2022': 3.01,
			'27.12.2022': 3.29,
			'28.12.2022': 3.56,
			'29.12.2022': 3.84,
			'30.12.2022': 4.11,
			'31.12.2022': 4.38,
			'01.01.2023': 4.66,
			'02.01.2023': 4.93,
			'03.01.2023': 5.21,
			'04.01.2023': 5.48,
			'05.01.2023': 5.75,
			'06.01.2023': 6.03,
			'07.01.2023': 6.3,
			'08.01.2023': 6.58,
			'09.01.2023': 6.85,
			'10.01.2023': 7.12,
			'11.01.2023': 7.4,
			'12.01.2023': 7.67,
			'13.01.2023': 7.95,
			'14.01.2023': 0,
			'15.01.2023': 0.27,
			'16.01.2023': 0.55,
			'17.01.2023': 0.82,
			'18.01.2023': 1.1,
			'19.01.2023': 1.37,
			'20.01.2023': 1.64,
			'21.01.2023': 1.92,
			'22.01.2023': 2.19,
			'23.01.2023': 2.47,
			'24.01.2023': 2.74,
			'25.01.2023': 3.01,
			'26.01.2023': 3.29,
			'27.01.2023': 3.56,
			'28.01.2023': 3.84,
			'29.01.2023': 4.11,
			'30.01.2023': 4.38,
			'31.01.2023': 4.66,
			'01.02.2023': 4.93,
			'02.02.2023': 5.21,
			'03.02.2023': 5.48,
			'04.02.2023': 5.75,
			'05.02.2023': 6.03,
			'06.02.2023': 6.3,
			'07.02.2023': 6.58,
			'08.02.2023': 6.85,
			'09.02.2023': 7.12,
			'10.02.2023': 7.4,
			'11.02.2023': 7.67,
			'12.02.2023': 7.95,
			'13.02.2023': 0
		}
	}
};

export const couponPaymentDates = {
	'1P1': {
		keyMoex: 'RU000A0ZZFP5',
		values: {
			'06.05.2020': 28.67,
			'05.08.2020': 28.67,
			'04.11.2020': 28.67,
			'03.02.2021': 28.67
		}
	},
	'1P2': {
		keyMoex: 'RU000A0ZZX35',
		values: {
			'09.12.2019': 31.16,
			'09.03.2020': 31.16,
			'08.06.2020': 31.16,
			'07.09.2020': 26.18,
			'07.12.2020': 26.18,
			'08.03.2021': 26.18,
			'07.06.2021': 26.18,
			'06.09.2021': 26.18,
			'06.12.2021': 26.18
		}
	},
	'1P3': {
		keyMoex: 'RU000A100Q35',
		values: {
			'13.08.2019': 9.86,
			'12.09.2019': 9.86,
			'12.10.2019': 9.86,
			'11.11.2019': 9.86,
			'11.12.2019': 9.86,
			'10.01.2020': 9.86,
			'09.02.2020': 9.86,
			'10.03.2020': 9.86,
			'09.04.2020': 9.86,
			'09.05.2020': 9.86,
			'08.06.2020': 9.86,
			'08.07.2020': 9.86,
			'07.08.2020': 9.86,
			'06.09.2020': 9.86,
			'06.10.2020': 9.86,
			'05.11.2020': 9.86,
			'05.12.2020': 9.86,
			'04.01.2021': 9.86,
			'03.02.2021': 9.86,
			'05.03.2021': 9.86,
			'04.04.2021': 9.86,
			'04.05.2021': 9.86,
			'03.06.2021': 9.86,
			'03.07.2021': 9.86,
			'02.08.2021': 9.86,
			'01.09.2021': 9.86,
			'01.10.2021': 9.86,
			'31.10.2021': 9.86,
			'30.11.2021': 9.86,
			'30.12.2021': 9.86,
			'29.01.2022': 9.86
		}
	},
	'2P1': {
		keyMoex: null,
		values: {
			'26.09.2020': 8.22,
			'26.10.2020': 8.22,
			'25.11.2020': 8.22,
			'25.12.2020': 8.22,
			'24.01.2021': 8.22,
			'23.02.2021': 8.22,
			'25.03.2021': 8.22,
			'24.04.2021': 8.22,
			'24.05.2021': 8.22,
			'23.06.2021': 8.22,
			'23.07.2021': 8.22,
			'22.08.2021': 8.22,
			'21.09.2021': 8.22,
			'21.10.2021': 8.22,
			'20.11.2021': 8.22,
			'20.12.2021': 8.22,
			'19.01.2022': 8.22,
			'18.02.2022': 8.22,
			'20.03.2022': 8.22,
			'19.04.2022': 8.22,
			'19.05.2022': 8.22,
			'18.06.2022': 8.22,
			'18.07.2022': 8.22,
			'17.08.2022': 8.22,
			'16.09.2022': 8.22,
			'16.10.2022': 8.22,
			'15.11.2022': 8.22,
			'15.12.2022': 8.22,
			'14.01.2023': 8.22,
			'13.02.2023': 8.22
		}
	}
};
